import { httpClient } from './http-client';

export interface ExecuteToolResponse<TOutput> {
  toolCallId: string;
  toolKey: string;
  status: 'EXECUTED' | 'PENDING_APPROVAL' | 'FAILED' | 'EXPIRED';
  output?: TOutput;
  error?: string;
  approvalRequestId?: string;
}

export async function executeTool<TInput, TOutput>(
  toolKey: string,
  input: TInput,
  transport?: { timeoutMs: number }
): Promise<ExecuteToolResponse<TOutput>> {
  return httpClient.post<ExecuteToolResponse<TOutput>, { toolKey: string; input: TInput }>(
    '/protected/tools/execute',
    { toolKey, input },
    transport === undefined ? undefined : { timeout: transport.timeoutMs }
  );
}
